import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, InputGroup, Card, Alert } from 'react-bootstrap';
import BotonMenu from './BotonMenu';
import Banners from './Banners'

// --- LÓGICA DE CÁLCULO DE AGUINALDO (Se mantiene igual) ---

const DIAS_LABORALES_ANIO = 365.25;
const DIAS_MES = 30;

// La función de cálculo ahora espera la fecha en formato ISO (YYYY-MM-DD),
// que es lo que el input type="date" proporciona.
const calcularAguinaldo = (ingresoISO, liquidacionISO, salarioBruto, montoSinRenta) => {
    
    // Aquí recibimos las fechas en formato ISO (YYYY-MM-DD)
    const fechaIngreso = new Date(ingresoISO);
    const fechaLiquidacion = new Date(liquidacionISO);
    const salario = parseFloat(salarioBruto);
    const exentoRenta = parseFloat(montoSinRenta);

    if (isNaN(salario) || salario <= 0 || fechaIngreso >= fechaLiquidacion) {
        return null;
    }

    // A. Antigüedad y Salario Diario
    const diferenciaTiempo = fechaLiquidacion.getTime() - fechaIngreso.getTime();
    const diasAntiguedad = diferenciaTiempo / (1000 * 60 * 60 * 24);
    const aniosAntiguedad = diasAntiguedad / DIAS_LABORALES_ANIO;
    const salarioDiario = salario / DIAS_MES;

    // B. Días de Aguinaldo
    let diasAguinaldo;
    if (aniosAntiguedad >= 1 && aniosAntiguedad < 3) {
        diasAguinaldo = 15;
    } else if (aniosAntiguedad >= 3 && aniosAntiguedad < 10) {
        diasAguinaldo = 19;
    } else if (aniosAntiguedad >= 10) {
        diasAguinaldo = 21;
    } else {
        const diasBase = 15; 
        diasAguinaldo = (diasAntiguedad / 365) * diasBase; 
    }

    // C. Aguinaldo Bruto
    let aguinaldoBruto = diasAguinaldo * salarioDiario;
    
    // D. Deducciones (Renta simplificada)
    let rentaAPagar = 0;
    if (aguinaldoBruto > exentoRenta) {
        const excedente = aguinaldoBruto - exentoRenta;
        rentaAPagar = excedente * 0.1; 
    }

    // E. Aguinaldo Líquido
    const aguinaldoLiquido = aguinaldoBruto - rentaAPagar;

    return {
        salarioDiario: salarioDiario.toFixed(2),
        aniosAntiguedad: aniosAntiguedad.toFixed(2),
        diasAguinaldo: diasAguinaldo.toFixed(2),
        aguinaldoBruto: aguinaldoBruto.toFixed(2),
        rentaAPagar: rentaAPagar.toFixed(2),
        aguinaldoLiquido: aguinaldoLiquido.toFixed(2),
    };
};

// ---------------------------------------------
// --- COMPONENTE REACT-BOOTSTRAP MODIFICADO ---
// ---------------------------------------------

const AguinaldoForm = () => {
    const [formData, setFormData] = useState({
        fechaIngreso: '',
        fechaLiquidacion: '',
        salarioMensualBruto: '',
        montoSinRenta: 1500.00, 
    });
    const [resultados, setResultados] = useState(null);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError(''); 
    };
    
    const handleSubmit = (event) => {
        event.preventDefault(); 

        const { fechaIngreso, fechaLiquidacion, salarioMensualBruto, montoSinRenta } = formData;

        if (!fechaIngreso || !fechaLiquidacion || !salarioMensualBruto) {
            setError('Por favor, complete todos los campos requeridos antes de calcular.');
            setResultados(null);
            return;
        }
        
        // ¡No se necesita conversión! Los valores ya están en formato YYYY-MM-DD
        
        const result = calcularAguinaldo(
            fechaIngreso,
            fechaLiquidacion,
            salarioMensualBruto,
            montoSinRenta
        );

        if (result) {
            setResultados(result);
            setError('');
        } else {
            setError('Error: Salario inválido o fechas incorrectas (Liquidación debe ser posterior a Ingreso).');
            setResultados(null);
        }
    };


    return (
        <Container className="my-5"> 
            <Row className="justify-content-center">
                <Banners BannerShow={1} Act={1}></Banners>                
                <Col md={8} lg={8}>
                <BotonMenu></BotonMenu>
                    <Card className="shadow p-3">
                        <Card.Body>
                        <Card.Title className="text-center mb-4">
                            <h2>Calculadora de Aguinaldo</h2>
                        </Card.Title>                            
                          
                            {error && <Alert variant="danger">{error}</Alert>}
                            
                            <Form onSubmit={handleSubmit}>
                                
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="fechaIngreso">
                                            <Form.Label>Fecha de Ingreso</Form.Label>
                                            <Form.Control 
                                                // **Cambiado de "text" a "date"**
                                                type="date" 
                                                name="fechaIngreso" 
                                                value={formData.fechaIngreso} 
                                                onChange={handleChange} 
                                                required 
                                            />
                                            <Form.Text muted></Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="fechaLiquidacion">
                                            <Form.Label>Fecha de liquidación</Form.Label>
                                            <Form.Control 
                                                // **Cambiado de "text" a "date"**
                                                type="date" 
                                                name="fechaLiquidacion" 
                                                value={formData.fechaLiquidacion} 
                                                onChange={handleChange} 
                                                required 
                                            />
                                            <Form.Text muted></Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group controlId="salarioMensualBruto" className="mb-3">
                                    <Form.Label>Salario Mensual Bruto</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            name="salarioMensualBruto"
                                            value={formData.salarioMensualBruto}
                                            onChange={handleChange}
                                            min="0"
                                            step="0.01"
                                            required
                                        />
                                    </InputGroup>
                                </Form.Group>
                                
                                <Form.Group controlId="montoSinRenta" className="mb-4">
                                    <Form.Label>Monto Exento de Renta ($1,500.00)</Form.Label>
{/*                                     
                                    <Form.Control
                                        type="number"
                                        name="montoSinRenta"
                                        value={formData.montoSinRenta}
                                        onChange={handleChange}
                                        min="0"
                                        step="0.01"
                                    />
                                    <Form.Text muted>
                                        Valor por defecto: $1,500.00
                                    </Form.Text> */}
                                </Form.Group>
                                
                                <Button variant="primary" type="submit" className="w-100 mb-3">
                                    Calcular Aguinaldo
                                </Button>

                            </Form>
                            
                            <hr/>

                            {/* --- Resultados --- */}
                            {resultados && (
                                <div className="results-container">
                                    <h5>Resultados del Cálculo</h5>

                                    <Row className="mb-2">
                                        <Col><p className="mb-0">Salario Diario:</p></Col>
                                        <Col className="text-end fw-bold"><p className="mb-0">${resultados.salarioDiario}</p></Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col><p className="mb-0">Antigüedad (años):</p></Col>
                                        <Col className="text-end fw-bold"><p className="mb-0">{resultados.aniosAntiguedad}</p></Col>
                                    </Row>
                                    <Row className="mb-3 border-bottom pb-2">
                                        <Col><p className="mb-0">Días Aguinaldo:</p></Col>
                                        <Col className="text-end fw-bold"><p className="mb-0">{resultados.diasAguinaldo}</p></Col>
                                    </Row>
                                    
                                    <Row className="mb-2 bg-light p-2 rounded">
                                        <Col><strong>Aguinaldo Bruto</strong></Col>
                                        <Col className="text-end text-success"><strong>${resultados.aguinaldoBruto}</strong></Col>
                                    </Row>
                                    
                                    <Row className="mb-2">
                                        <Col>Deducción Renta (-)</Col>
                                        <Col className="text-end text-danger">${resultados.rentaAPagar}</Col>
                                    </Row>

                                    <Row className="mb-2 border-top pt-2">
                                        <Col><strong>Aguinaldo Líquido (=)</strong></Col>
                                        <Col className="text-end text-primary"><strong>${resultados.aguinaldoLiquido}</strong></Col>
                                    </Row>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                    <Row>
                        <Banners BannerShow={2} Act={1}></Banners>
                    </Row>                    
                </Col>
                <Banners BannerShow={1} Act={1}></Banners>
            </Row>
        </Container>
    );
};

export default AguinaldoForm;